// Convert string into sentence case, also replaces underscores with spaces
export function toSentenceCase(str = '') {
    return str && str.length > 2 ? (str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).replace(/_/g, ' ') : '';
}
// convert string to snake case that remove all special characters and spaces
export function toSnakeCase(str = '') {
    return str.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
}
